import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import { amber, green } from '@material-ui/core/colors';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import WarningIcon from '@material-ui/icons/Warning';
import { makeStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import BootstrapTooltip from '../../shared/components/ToolTips';


const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const useStyles1 = makeStyles(theme => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.main,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  plusBtn:{
    backgroundColor: "#20414a", width:'38px', height:'38px'
  }

}));

function MessageContentWrapper(props) {
  const classes = useStyles1();
  const { className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];
  return (
    <SnackbarContent
      className={clsx(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={clsx(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      action={props.otherProps && props.otherProps.showCreateContactButton ? [
        <BootstrapTooltip title="Create New Contact">
        <Fab color="secondary" className={classes.plusBtn} onClick={() => props.otherProps.handleCreateUser(true)}>
          <AddIcon />
        </Fab></BootstrapTooltip>, 
        <IconButton key="close" aria-label="close" color="inherit" onClick={onClose}>
          <CloseIcon className={classes.icon} />
        </IconButton>
      ] : <IconButton key="close" aria-label="close" color="inherit" onClick={onClose}>
            <CloseIcon className={classes.icon} />
          </IconButton>}
      {...other}
    />
  );
}

MessageContentWrapper.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(['error', 'info', 'success', 'warning']).isRequired,
};


export default class MessageBar extends React.Component {


  constructor(props){
    super(props);
    this.state = {open:false,message:"",variant:"success",options:{
        vertical: 'bottom',
        horizontal: 'right',
        variant: 'success'
    }}
    
  }

  handleClose = (event) => {
    this.props.disableMessage();
  };
  

  render(){
    return (
        <div>
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            open={this.props.open}
            autoHideDuration={6000}
            onClose={this.handleClose}
            style={{zIndex:999999}}
          >
            <MessageContentWrapper
              onClose={this.handleClose}
              variant={this.props.variant}
              message={this.props.message}
              otherProps={this.props.otherProps}
            />
          </Snackbar>
          
        </div>
    );
  }
}